import React from 'react';
import { useCtx } from './estado.jsx';
import { Gate } from './componentes/Gate.jsx';
import { Sidebar } from './componentes/Sidebar.jsx';
import { TableroView } from './componentes/Tablero.jsx';
import { ClientesView } from './componentes/Clientes.jsx';
import { ValidarView } from './componentes/Validar.jsx';
import { MiSedeView } from './componentes/MiSede.jsx';
import { GlobalView, ClientesGlobalView, EditSedeView, AltaSedeView } from './componentes/VistasAleph.jsx';
import { AccesosView } from './componentes/Accesos.jsx';
import { CodigosView } from './componentes/Codigos.jsx';
import { ModalActivo } from './componentes/Modales.jsx';

export default function App() {
  const { session, view } = useCtx();

  // Sin sesión no se monta nada del hub: ni siquiera se piden datos, así que
  // no hay peticiones colgando ni pantallas a medias detrás del login.
  if (!session) return <Gate />;

  const vistas = {
    global: GlobalView,
    clientesglobal: ClientesGlobalView,
    sede: TableroView,
    editsede: EditSedeView,
    alta: AltaSedeView,
    accesos: AccesosView,
    codigos: CodigosView,
    clientes: ClientesView,
    validar: ValidarView,
    manage: MiSedeView,
  };
  const Vista = vistas[view] || (session.rol === 'aleph' ? GlobalView : TableroView);

  // El identificador y la clase importan: el CSS declara #hub{display:none} y
  // #hub.show{display:flex}. Ese flex es lo que coloca el sidebar y el
  // contenido en paralelo. Con cualquier otra clase, el main cae debajo del
  // sidebar —que ocupa toda la altura— y la pantalla se ve en blanco.
  return (
    <div id="hub" className="show">
      <Sidebar />
      <main className="main"><Vista /></main>
      <ModalActivo />
    </div>
  );
}
